module.exports = __webpack_public_path__ + "media/didgeridoo.2d131d3e.ogg";